export { BreadCrumbBmL10n } from './breadcrumb-bm-l10n.class';
